<!-- eslint-disable vue/multi-word-component-names -->
<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="flex h-screen w-full">
      <div
        :style="{ backgroundImage: `url(${imagemLogin})` }"
        class="bg-no-repeat bg-cover bg-center bg-aqua flex-none w-3/5 lg:block hidden h-full"
      ></div>

      <div
        class="d-theme-dark-bg w-full xl:w-4/5 h-full flex items-center justify-center"
      >
        <div class="vx-col w-full xl:w-4/5 d-theme-dark-bg">
          <div class="p-8">
            <div class="vx-card__title mb-16 flex items-center justify-center">
              <div class="vx-col lg:w-1/2">
                <img
                  v-if="logo"
                  style="max-width: 180px"
                  :src="logo"
                  alt="login"
                  class="mx-auto"
                />
              </div>
            </div>
            <form
              role="form"
              @submit.stop.prevent="onSubmit"
              @keydown.enter.prevent
            >
              <div class="mb-8">
                <h2 style="color: #2b50bb; font-weight: bold" class="mb-4">
                  Login
                </h2>
                <p style="color: #000">
                  Para acessar informe as credenciais abaixo
                </p>
              </div>

              <vs-input
                name="email"
                color="#2B50BB"
                icon="icon icon-user"
                icon-pack="feather"
                v-model="form.emailConsultor"
                class="w-full no-icon-border"
                v-validate="{ required: true }"
                :state="validateState('email')"
                :class="validateClass('email')"
              />
              <div class="flex" v-if="!esqueciSenha">
                <vs-input
                  id="inputSenha"
                  :type="`${tipoInputSenha}`"
                  color="#2B50BB"
                  name="Senha"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  v-model="form.senha"
                  v-validate="{ required: true }"
                  :state="validateState('Senha')"
                  :class="validateClass('Senha')"
                  class="w-full mt-6 no-icon-border h-12"
                  v-on:keyup.enter="onSubmit"
                />
                <!-- botão para mostrar ou não a senha que o usuário digitar no login -->
                <vs-button
                  :icon="`${iconIputSenha}`"
                  @click.stop.prevent="exibirSenha()"
                  class="absolute mt-6 right-0 mr-8 xl:mr-32 h-12"
                  color="none"
                  icon-pack="feather"
                  text-color="rgb(169,169,169)"
                ></vs-button>
              </div>
              <div class="flex flex-wrap justify-between my-5">
                <vs-alert
                  v-if="$validator.errors.all().length > 0"
                  color="danger"
                  title="Atenção!!"
                  active="true"
                  class="my-3"
                  style="height: auto !important"
                >
                  <ul>
                    <li
                      class="mb-2"
                      v-for="error in $validator.errors.all()"
                      :key="error.id"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </vs-alert>
              </div>
              <div class="flex btn-actions justify-between items-center">
                <p v-if="contando">
                  Você poderá solicitar uma nova senha em
                  {{ contador }} segundos.
                </p>

                <vs-button
                  v-if="erroLogin == false && !esqueciSenha"
                  class="float-left btn-actions w-32"
                  color="#2B50BB"
                  >Login</vs-button
                >

                <a
                  style="color: #000"
                  v-if="!esqueciSenha && !contando"
                  @click="esqueciSenha = true"
                  class="float-right esqueciSenhaLink btn-actions"
                  ><vs-icon
                    icon-pack="feather"
                    icon="icon-lock"
                    color="black"
                  ></vs-icon>
                  Esqueci minha senha</a
                >

                <a
                  style="color: #2b50bb"
                  v-if="esqueciSenha"
                  @click="esqueciSenha = false"
                  class="float-left esqueciSenhaLink btn-actions"
                  >Voltar</a
                >

                <vs-button
                  v-if="esqueciSenha"
                  class="float-right btn-actions"
                  color="#2B50BB"
                  >Enviar Nova Senha</vs-button
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import ability from './../../services/ability';
import functions from './../../utils/functions';
import {
  getDataLoginDefault,
  saveDataLoginDefault,
  saveListEmpresas,
} from './../../services/multiple-empresa';

export default {
  data() {
    return {
      erroLogin: true,
      email: '',
      password: '',
      idEmpresaAux: null,
      idEmpresa: null,
      empresaSelecionada: false,
      tipoInputSenha: 'password',
      iconIputSenha: 'icon icon-eye',
      form: {
        placa: null,
        email: null,
        emailConsultor: null,
        senha: null,
        idEmpresa: null,
      },
      checkbox_remember_me: false,
      logo: '',
      imagemLogin: '',
      esqueciSenha: false,
      contando: false,
      contador: 45,
      isBP: false,
      systemNotice: '{}',
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        if (this.esqueciSenha) {
          this.validaEmailConsultor();
          return;
        }
        this.$vs.loading();
        service
          .login('Login', 'makeLogin', this.form)
          .then((res) => {
            this.$vs.loading.close();

            const {
              token,
              permission,
              idEmpresaDefault,
              empresas,
              redirect,
              trocarSenha,
            } = res.data;

            localStorage.setItem('user-token', token);
            localStorage.setItem('show-news-modal', 'true');

            saveDataLoginDefault({
              idEmpresaDefault,
              token,
              systemNotice: this.systemNotice,
            });
            saveListEmpresas(empresas);

            ability.saveLocalPermission(permission);

            if (this.$ability && permission) {
              this.$ability.update(permission);
            }

            if (trocarSenha && redirect == 'trocarSenha') {
              window.location.href = 'trocarSenha';
              return;
            } else {
              this.$router.push({
                path: 'dashboard',
              });
            }
            //this.$router.push("/dashboard");
          })
          .catch((e) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
          });
      });
    },
    async selecionaEmpresa() {
      if (window.location.hostname.includes('bemprotege')) {
        this.isBP = true;
      }

      //#region Local Storage
      const idEmpresa = 118;
      const dataLoginDefault = 118;

      if (dataLoginDefault) {
        const { idEmpresaDefault } = dataLoginDefault;

        if (idEmpresaDefault) {
          this.form.idEmpresa = idEmpresaDefault;
        } else {
          if (idEmpresa) {
            this.form.idEmpresa = idEmpresa;
          }
        }
      }

      //#endregion

      //#region Query Params
      let idEmpresaQueryParam = this.$route.query.idEmpresa;

      if (idEmpresaQueryParam) {
        // @Alternar empresa 117 para 118
        if (idEmpresaQueryParam === '117') {
          idEmpresaQueryParam = '118';
        }

        this.form.idEmpresa = idEmpresaQueryParam;
        saveDataLoginDefault(idEmpresaQueryParam);
      }

      //#endregion

      //#region Input

      const idEmpresaInput = this.idEmpresaAux;
      if (idEmpresaInput) {
        this.form.idEmpresa = idEmpresaInput;
        saveDataLoginDefault(idEmpresaInput);
      }

      //#endregion

      if (this.form.idEmpresa) {
        localStorage.setItem('idEmpresa', this.form.idEmpresa);
        await this.buscaDadosEmpresa();
      }
    },
    buscaDadosEmpresa() {
      return new Promise((resolve) => {
        service
          .getAll('Login', {}, 'buscarEmpresa/' + this.form.idEmpresa)
          .then((res) => {
            this.logo = res.data.logo;
            this.imagemLogin = res.data.imagemLogin;
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('imagemLogin', this.imagemLogin);
            this.$store.dispatch('updateLogo', this.logo);
            this.systemNotice = res.data.systemNotice;
            this.idEmpresaAux = this.form.idEmpresa;
            this.empresaSelecionada = true;
            this.erroLogin = false;
            resolve();
          })
          .catch(() => {
            const erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: erroConexao,
              color: 'danger',
            });
            this.erroLogin = true;
            service.maintenance(this.$router);
            this.empresaSelecionada = false;
          });
      });
    },
    exibirSenha() {
      if (this.tipoInputSenha == 'password') {
        this.tipoInputSenha = 'text';
        this.iconIputSenha = 'icon icon-eye-off';
      } else {
        this.tipoInputSenha = 'password';
        this.iconIputSenha = 'icon icon-eye';
      }
    },
    validaEmailConsultor() {
      this.$vs.loading();
      service
        .post('Login', 'valida-email-consultor', this.form)
        .then((res) => {
          this.$vs.loading.close();
          if (!res.data.length) {
            this.notify(
              'Não foi encontrado nenhum usuário com email informado',
              'danger',
            );
            return;
          }
          this.esqueciSenha = false;
          this.contagemRegressiva();
          const msg = this.getMessage({ data: res.data[0] });
          this.notify(msg, 'success');
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.notify(e, 'danger');
        });
    },
    getMessage(res) {
      if (res.data.email) {
        return `Sua nova senha foi enviada para o email ${res.data.email}`;
      }

      if (res.data.sentWhatsapp && res.data.celular) {
        return `Sua nova senha foi enviada via mensagem no WhatsApp para o celular ${functions.escondeCelular(
          res.data.celular,
        )}`;
      }

      if (res.data.celular) {
        return `Sua nova senha foi enviada para o celular ${functions.escondeCelular(
          res.data.celular,
        )}`;
      }
    },
    notify(mensagem, tipo) {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: mensagem,
        color: tipo,
      });
    },
    contagemRegressiva() {
      this.mostrarContador();
      const diminuir1Segundo = setInterval(() => {
        this.contador--;
        this.contador === 0 && clearInterval(diminuir1Segundo);
        this.contador === 0 && localStorage.removeItem('contando');
        this.contador === 0 && this.mostrarContador();
      }, 1000);
    },
    mostrarContador() {
      this.contando = !this.contando;
      this.contador = 45;
    },
    verificarSeContando() {
      if (localStorage.getItem('contando')) {
        this.contagemRegressiva();
      }
    },
  },
  mounted() {
    service.maintenance(this.$router);
    this.$validator.localize('ptBr', locale);
    this.selecionaEmpresa();
    this.verificarSeContando();
  },
};
</script>
<style>
#inputSenha {
  padding: 0.7rem 2.5rem 0.7rem 3rem;
}

.esqueciSenhaLink {
  cursor: pointer;
}

.esqueciSenhaLink:hover {
  text-decoration: underline;
}

.vs-con-input {
  height: 47px;
}

.vs-con-input > input {
  height: 47px;
}

.btn-actions {
  height: 47px !important;
}
</style>
